// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1CqTH","svg":"styles__svg___3TOKk","hidden":"styles__hidden___2JRT_"};